import { FormFieldTypes } from "../../../../../../../data/formFieldType";

const initState = {
  dtEffectiveDate:null,
  dtEndDate:null,
  lSalesRepKey:0,
  sCommissonRate:null
}

export const EditCommissionRatesConfig = {
  name: "EditCommissionRates",
  initialState: initState,
  section: [
    {
      sectionId: "EditCommissionRatesConfig",
      title: "Edit Commission Rates",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12 pr-5",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "dtEffectiveDate",
          label: "Effective Date :",
          Field_Name: "Effective Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtEffectiveDate",
          fieldSetting: {
            placeholder: "Effective Date",
            subTitle: " ",
          },
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 po-to-datepicker po-input",
          },
        },
        {
          id: "dtEndDate",
          label: "End Date :",
          Field_Name: "End Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtEndDate",
          fieldSetting: {
            placeholder: "End Date",
            subTitle: " ",
          },
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 po-to-datepicker po-input",
          },
        },
        {
          id: "lSalesRepKey",
          label: "Sales Rep : ",
          Field_Name: "Sales Rep",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lSalesRepKey",
          fieldSetting: {
              isEnableOnChange: true,
              placeholder: "Select Sales Rep",
              options: [],
          },
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },
        {
          id: "sCommissonRate",
          label: "Commission Rate : ",
          Field_Name: "Commission Rate",
          fieldType: FormFieldTypes.NUMERIC,
          dataField: "sCommissonRate",
          fieldSetting: {
            placeholder: "Commission Rate",
            allowSpace: true,
          },
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },
      ],
    },
  ],
};
